/**
 * What a reservation's pending charge says once it has settled (DNKADM-0489 follow-up).
 *
 * dink-api keeps the pending-charge row after it leaves `pending` (`PendingChargeStatus`:
 * `pending`, `charged`, `cancelled`, `failed`, sent lowercase). The calendar tile and the
 * drawer's charge block both read this one mapper so they never disagree.
 *
 * - `charged` → "Fee charged", `failed` → "Fee failed", `cancelled` → "Fee cancelled".
 * - `pending`, a blank status, or a value this build does not know → null: the caller keeps
 *   its pending wording ("charge pending" on the tile, "Pending charge" in the drawer).
 */
export type SettledFeeLabel = 'Fee charged' | 'Fee failed' | 'Fee cancelled';

/** The settled label for a pending-charge status, or null while it is pending or unknown. */
export function settledFeeLabel(status: string | null | undefined): SettledFeeLabel | null {
  if (typeof status !== 'string') return null;
  switch (status.trim().toLowerCase()) {
    case 'charged':
      return 'Fee charged';
    case 'failed':
      return 'Fee failed';
    case 'cancelled':
      return 'Fee cancelled';
    default:
      return null;
  }
}
